import CustomSelect from "../../SelectSearch/CustomSelect";

const PurchaseItemForm = ({
    currentItem,
    setCurrentItem,
    isExistingItem,
    editableClass,
    readonlyClass,
    departmentOptions,
    STOCK_TYPE_OPTIONS,
    error,
    handleAddItem,
    handleCancel,
    handleClearAll,
    tableItems,
    editingIndex
}) => {
    return (
        <div className="grid grid-cols-3 gap-y-3 gap-x-2 mb-4 w-1/3 content-start">

            <label className="col-span-1 text-sm font-medium text-gray-700 self-center">Brand Name</label>
            <input
                type="text"
                placeholder="Brand Name"
                value={currentItem.BrandName}
                readOnly={isExistingItem}
                onChange={!isExistingItem ? (e) => setCurrentItem({ ...currentItem, BrandName: e.target.value }) : undefined}
                className={`${isExistingItem ? readonlyClass : editableClass}`}
            />

            <label className="col-span-1 text-sm font-medium text-gray-700 self-center">Quantity *</label>
            <input
                type="number"
                placeholder="Quantity"
                value={currentItem.quantity}
                onChange={(e) => setCurrentItem({ ...currentItem, quantity: e.target.value })}
                className={editableClass}
                step="any"
            />

            <label className="col-span-1 text-sm font-medium text-gray-700 self-center">Rate *</label>
            <input
                type="number"
                placeholder="Rate"
                value={currentItem.Rate}
                onChange={(e) => setCurrentItem({ ...currentItem, Rate: e.target.value })}
                className={editableClass}
                step="any"
            />

            <label className="col-span-1 text-sm font-medium text-gray-700 self-center">Primary Unit</label>
            <input
                type="text"
                placeholder="Primary Unit"
                value={currentItem.primary_unit}
                readOnly={isExistingItem}
                onChange={!isExistingItem ? (e) => setCurrentItem({ ...currentItem, primary_unit: e.target.value }) : undefined}
                className={`${isExistingItem ? readonlyClass : editableClass}`}
            />

            <label className="col-span-1 text-sm font-medium text-gray-700 self-center">Secondary Unit</label>
            <input
                type="text"
                placeholder="e.g. dozen, pack"
                value={currentItem.secondary_unit}
                readOnly={isExistingItem}
                onChange={!isExistingItem ? (e) => setCurrentItem({ ...currentItem, secondary_unit: e.target.value }) : undefined}
                className={`${isExistingItem ? readonlyClass : editableClass}`}
            />

            <label className="col-span-1 text-sm font-medium text-gray-700 self-center">Department</label>
            {isExistingItem ? (
                <input
                    type="text"
                    value={currentItem.Department}
                    readOnly
                    className={readonlyClass}
                />
            ) : (
                <div className="col-span-2 text-sm">
                    <CustomSelect
                        options={departmentOptions}
                        value={currentItem.Department}
                        onChange={(val) =>
                            setCurrentItem({
                                ...currentItem,
                                Department: val,
                            })
                        }
                        placeholder="Select Department"
                    />
                </div>
            )}

            <label className="col-span-1 text-sm font-medium text-gray-700 self-center">Group Name</label>
            <input
                type="text"
                placeholder="Group Name"
                value={currentItem.GroupName}
                readOnly={isExistingItem}
                onChange={!isExistingItem ? (e) => setCurrentItem({ ...currentItem, GroupName: e.target.value }) : undefined}
                className={`${isExistingItem ? readonlyClass : editableClass}`}
            />

            <label className="col-span-1 text-sm font-medium text-gray-700 self-center">Stock Type *</label>
            <div className="col-span-2">
                <div className={`flex rounded-md border overflow-hidden h-[34px] ${!currentItem.stocktype && error ? "border-red-400" : "border-gray-300"}`}>
                    {STOCK_TYPE_OPTIONS.map((opt) => (
                        <button
                            key={opt.value}
                            type="button"
                            onClick={() => setCurrentItem({ ...currentItem, stocktype: opt.value })}
                            className={`flex-1 text-sm transition-colors focus:outline-none ${currentItem.stocktype === opt.value ? "bg-blue-600 text-white" : "bg-white text-gray-700 hover:bg-gray-50"}`}
                        >
                            {opt.label}
                        </button>
                    ))}
                </div>
                {!currentItem.stocktype && error && (
                    <p className="mt-1 text-xs text-red-500">Required</p>
                )}
            </div>

            {/* Action buttons */}
            <div className="col-span-3 flex items-center gap-2 justify-end mt-1">
                {/* Clear all — only show when table has items */}
                {tableItems.length > 0 && (
                    <button
                        onClick={handleClearAll}
                        className="px-3 py-1.5 text-sm border border-red-200 text-red-600 rounded-md hover:bg-red-50 transition-colors"
                    >
                        Clear All
                    </button>
                )}
                {/* Cancel — only show when something is in progress */}
                {currentItem.ItemName && (
                    <button
                        onClick={handleCancel}
                        className="px-3 py-1.5 text-sm border border-gray-300 text-gray-600 rounded-md hover:bg-gray-50 transition-colors"
                    >
                        Cancel
                    </button>
                )}
                <button
                    onClick={handleAddItem}
                    className="px-4 py-1.5 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-1 focus:ring-blue-500 transition-colors"
                >
                    {editingIndex !== null ? "Update Item" : "Add Item to List"}
                </button>
            </div>
        </div>
    );
};

export default PurchaseItemForm;